import React from "react";
import { useTranslation } from 'react-i18next';
import fusoChat from "../../assets/fusoChat.svg";
import rephraseQuestion from "../../assets/rephrasePnc.svg";
import "./RephraseQuestion.css";

const RephraseQuestion = ({ message }) => {
  const { t, i18n  } = useTranslation();
  
  return (
    <div className="chatsuggPnc">
      <div className="iconOuter">
        <img src={fusoChat} alt="FUSO" className="w-6 h-6 fusoLogoSmall" />
      </div>
      <div className="bg-red-50 p-4 pncChatFirst custom-radius">
        <div>
          <p className="chatSuggestionPnc iconLastPnc">
            <span>
                {t('gotItMessage')}
            </span>
            <img
              src={rephraseQuestion}
              alt="Rephrase icon"
              style={{
                width: "auto",
                display: "inline",
                marginLeft: "10px",
                marginTop: "-10px",
              }}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

export default RephraseQuestion;
